import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import CmsLoader from '../loader/Cms1';
import Meta from './layout/Meta'

export default function Privacy() {
    const [pageloader, setPageloader] = useState(false);
    const [pagedata, setPagedata] = useState();

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/8')
                .then((response) => {
                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setPagedata]);

    return (
        <>
            <Meta id={8} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Privacy Policy" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Privacy Policy</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Privacy Policy</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        {
                            pageloader ?
                                <CmsLoader />
                                :

                                <>
                                    {
                                        pagedata ?
                                            <div className="row" >
                                                <div className="col-12 text-center">
                                                    <span className="SubTitle">{pagedata.title}</span>
                                                    <h2 className="Heading">{pagedata.heading}</h2>
                                                </div>
                                                <div className="col-12 CmsPage" dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                            </div>
                                            :
                                            ''
                                    }
                                </>

                        }
                    </div>
                </section>
            </main>
        </>
    )
}
